"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scaleFunction = exports.getScaleFactor = exports.getRawDocumentDimensions = exports.getDocumentDimensions = void 0;
const constants_1 = require("../constants/constants");
// Default dimensions (US Letter at 96 DPI + 20% padding)
// Base: 816x1056 (8.5" x 11" at 96 DPI)
// With padding: 979.2x1267.2
const DEFAULT_PAGE_WIDTH = 816;
const DEFAULT_PAGE_HEIGHT = 1056;
/**
 * Get the document's page dimensions.
 * Returns stored PDF dimensions if available, otherwise defaults to US Letter.
 * Applies 20% padding to match existing DOCUMENT_WIDTH/DOCUMENT_HEIGHT behaviour.
 */
const getDocumentDimensions = (document) => {
    // Use stored PDF dimensions if available
    const baseWidth = (document === null || document === void 0 ? void 0 : document.page_width) || DEFAULT_PAGE_WIDTH;
    const baseHeight = (document === null || document === void 0 ? void 0 : document.page_height) || DEFAULT_PAGE_HEIGHT;
    // Apply 20% padding to match existing constants
    return {
        width: baseWidth + baseWidth * 0.2,
        height: baseHeight + baseHeight * 0.2,
    };
};
exports.getDocumentDimensions = getDocumentDimensions;
/**
 * Get the document's raw page dimensions (without padding).
 * Useful for coordinate conversion calculations.
 */
const getRawDocumentDimensions = (document) => {
    return {
        width: (document === null || document === void 0 ? void 0 : document.page_width) || DEFAULT_PAGE_WIDTH,
        height: (document === null || document === void 0 ? void 0 : document.page_height) || DEFAULT_PAGE_HEIGHT,
    };
};
exports.getRawDocumentDimensions = getRawDocumentDimensions;
/**
 * Returns the current viewport scale factor based on screen width.
 * Used for unscaling values when converting from visual to stored coordinates.
 *
 * Breakpoints:
 * - <= 375px: 0.35 (small phones)
 * - 376-400px: 0.38
 * - 401-500px: 0.45
 * - 501-600px: 0.5
 * - 601-DOCUMENT_WIDTH: proportional
 * - > DOCUMENT_WIDTH: 1.0 (no scaling)
 */
const getScaleFactor = (docWidth = constants_1.DOCUMENT_WIDTH) => {
    if (typeof window === "undefined")
        return 1;
    const width = window.innerWidth;
    if (width <= 375)
        return 0.35;
    if (width > 375 && width <= 400)
        return 0.38;
    if (width > 400 && width <= 500)
        return 0.45;
    if (width > 500 && width <= 600)
        return 0.5;
    if (width > 600 && width < docWidth)
        return width / docWidth;
    return 1;
};
exports.getScaleFactor = getScaleFactor;
/**
 * Scales a size value based on current viewport width.
 * Used for positioning elements responsively on the document canvas.
 *
 * @param size - The size value to scale
 * @param docWidth - Optional document width to use for scaling (defaults to DOCUMENT_WIDTH)
 */
const scaleFunction = (size, docWidth = constants_1.DOCUMENT_WIDTH) => {
    const width = window.innerWidth;
    // Very small screens (small phones) - scale aggressively to fit
    if (width <= 375) {
        return size * 0.35;
    }
    if (width > 375 && width <= 400) {
        return size * 0.38;
    }
    if (width > 400 && width <= 500) {
        return size * 0.45;
    }
    if (width > 500 && width <= 600) {
        return size * 0.5;
    }
    // For viewports between 600px and docWidth, scale proportionally
    // This ensures fields stay in relative position when container is constrained
    if (width > 600 && width < docWidth) {
        return size * (width / docWidth);
    }
    return size;
};
exports.scaleFunction = scaleFunction;
